module.exports = __webpack_public_path__ + "img/3.d286dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hubali_office/3.jpg
// module id = 1831
// module chunks = 1